const styles = {
  container: 'flex items-center justify-center',
  content: 'flex flex-col items-center gap-y-2',

  head: 'flex flex-col items-center mt-24',
  foot: '',

  title:
    'font-nbi-pro text-8xl sm:text-[12rem] xl:text-[20rem] opacity-5 font-thin text-center pointer-events-none text-black dark:text-white',
  description:
    'mt-8 text-3xl font-semibold tracking-display text-black dark:text-white',

  button: {
    container: 'flex flex-row items-center gap-x-4 text-black dark:text-white',
    label: 'text-center hover:underline ',
  },
};

export default styles;
